import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/channelPartnerRequests/useChannelPartnerRequestQueryKeys.ts
var t = e("channel-partner-requests", {
	list: (e) => e === void 0 ? ["list"] : ["list", e],
	log: (e) => e === void 0 ? ["log"] : ["log", e],
	detail: (e) => ["detail", e],
	stats: (e) => e === void 0 ? ["stats"] : ["stats", e],
	series: (e) => e === void 0 ? ["series"] : ["series", e],
	byDeveloper: (e) => e === void 0 ? ["by-developer"] : ["by-developer", e]
});
//#endregion
export { t as channelPartnerRequestQueryKeys };
